import React from 'react'

export type IconBaseProps = {
  viewBoxSize?: number
  viewBoxWidth?: number
  viewBoxHeight?: number
  size?: React.CSSProperties['height']
  hGradient?: {
    startColor: React.CSSProperties['color']
    endColor: React.CSSProperties['color']
  }
  'data-test-id'?: string
} & React.SVGProps<SVGSVGElement>

export const IconBase: React.FC<IconBaseProps> = ({
  viewBox,
  viewBoxSize = 16,
  children,
  viewBoxWidth = viewBoxSize,
  viewBoxHeight = viewBoxSize,
  size = '1em',
  style,
  color,
  hGradient,
  ...otherProps
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox || `0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={size}
      height={size}
      style={{ verticalAlign: 'middle', ...style }}
      preserveAspectRatio="xMidYMid meet"
      {...otherProps}
    >
      {hGradient && (
        <linearGradient
          x1="100%"
          y1="100%"
          x2="0%"
          y2="0%"
          id="linearGradient-1"
        >
          <stop stopColor={hGradient.startColor} offset="0%" />
          <stop stopColor={hGradient.endColor} offset="100%" />
        </linearGradient>
      )}
      <g fill={hGradient ? 'url(#linearGradient-1)' : color || 'currentColor'}>
        {children}
      </g>
    </svg>
  )
}
